import React, { useState, useEffect } from "react"
import {
  TestimonialCarouselContainer,
  TestimonialCarouselMain,
  TestimonialCarouselSecondary,
  CarouselSlide,
  CarouselSlideSmall,
  SlideImg,
  CarouselsContainer,
  CarouselsWrapper,
  TextWrapper,
  AnimatedText,
} from "./style"
import { useStaticQuery, graphql } from "gatsby"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import usePrevious from "hooks/usePrevious.js"
import "./transitions.css"

const TestimonialCarousel = ({ preview }) => {
  const data = useStaticQuery(
    graphql`
      query {
        wpgraphql {
          testimonials(where: { orderby: { field: MENU_ORDER, order: ASC } }) {
            nodes {
              testimonial {
                author
                description
                fieldGroupName
                message
                img {
                  sourceUrl
                  srcSet
                  mediaDetails {
                    height
                    width
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  let testimonialsData =
    preview?.testimonials?.nodes || data?.wpgraphql?.testimonials?.nodes

  const hasTwo = testimonialsData.length === 2

  if (hasTwo) {
    testimonialsData = [...testimonialsData, ...testimonialsData]
  }

  const [slideIndex, setSlideIndex] = useState(0)
  const [slideContent, setSlideContent] = useState(
    testimonialsData[0].testimonial
  )
  // console.log("slideContent:", slideContent)
  const previousSlideIndex = usePrevious(slideIndex) || -1
  const [clickedIndex, setClickedIndex] = useState(null)
  const [nextTrigger, setNextTrigger] = useState(null)

  const forwards =
    slideIndex === testimonialsData.length - 1 && previousSlideIndex <= 0
      ? false
      : (slideIndex === 0 &&
          previousSlideIndex === testimonialsData.length - 1) ||
        slideIndex > previousSlideIndex
      ? true
      : false

  const handleSlideSelection = index => {
    setSlideIndex(index)
    setSlideContent(testimonialsData[index].testimonial)
  }

  useEffect(() => {
    if (clickedIndex || clickedIndex === 0) {
      setNextTrigger(c => c + 1)
    }
  }, [clickedIndex])

  console.log("testimonialsData:", testimonialsData)

  return (
    <TestimonialCarouselContainer>
      <TextWrapper>
        <h4>What They're Saying</h4>

        <TransitionGroup
          className="transitionGroup"
          childFactory={child =>
            React.cloneElement(child, {
              classNames: forwards ? "forwards" : "backwards",
            })
          }
        >
          <CSSTransition
            key={slideIndex}
            in={true}
            appear={true}
            timeout={10000}
            mountOnEnter={true}
            unmountOnExit={true}
            enter={true}
            exit={true}
          >
            <AnimatedText>
              <blockquote>{`“${slideContent.message}”`}</blockquote>

              <p>
                <span className="name">{slideContent.author}</span>{" "}
                {slideContent.description}
              </p>
            </AnimatedText>
          </CSSTransition>
        </TransitionGroup>
      </TextWrapper>
      <CarouselsContainer>
        <CarouselsWrapper>
          <TestimonialCarouselMain
            gap={0}
            loop
            slidesToShow={1}
            onChange={handleSlideSelection}
            dotColor="#A5368C"
            speed={9}
            nextTrigger={nextTrigger}
            hasTwo={hasTwo}
          >
            {testimonialsData.map((item, index) => {
              if (item?.testimonial?.img) {
                item.testimonial.img.sizes = "(min-width: 1024px) 360px, 100vw"
              }

              return (
                <CarouselSlide key={index}>
                  <SlideImg fluid={item.testimonial.img} />
                </CarouselSlide>
              )
            })}
          </TestimonialCarouselMain>

          <TestimonialCarouselSecondary
            gap={0}
            loop
            slidesToShow={hasTwo ? [1.2, 1] : [1.4, 2]}
            hideDots
            hasTwo={hasTwo}
            hideButtons
            startIndex={1}
            passedIndex={slideIndex + 1}
            speed={9}
            onSlideClick={index => setClickedIndex(c => c + 1)}
          >
            {testimonialsData.map((item, index) => {
              return (
                <CarouselSlideSmall hasTwo={hasTwo} key={index}>
                  <SlideImg fluid={item.testimonial.img} />
                </CarouselSlideSmall>
              )
            })}
          </TestimonialCarouselSecondary>
        </CarouselsWrapper>
      </CarouselsContainer>
    </TestimonialCarouselContainer>
  )
}

export default TestimonialCarousel
